import { FC, ReactNode } from 'react';

export type EmptyStateProps = {
  title: string;
  description?: ReactNode;
  /** The caller's action, placed under the description. */
  action?: ReactNode;
  /** Placement only: the frame, centring and type are the empty state's. */
  className?: string;
};

/**
 * The one empty state.
 *
 * It owns the whole appearance - the dashed frame, the centring and the muted
 * type - so a page with nothing to show stops hand-rolling a dashed box.
 */
const EmptyState: FC<EmptyStateProps> = ({ title, description, action, className }) => (
  <div className={['ui-empty-state', className].filter(Boolean).join(' ')}>
    <p className="ui-empty-state-title">{title}</p>
    {description && <p className="ui-empty-state-desc">{description}</p>}
    {action && <div className="ui-empty-state-action">{action}</div>}
  </div>
);

export default EmptyState;
